import { z } from 'zod';
/**
 * The single failure shape for every `/api/v1` endpoint.
 *
 * Every non-2xx response has this body, so clients branch on `error.code`
 * rather than parsing messages or guessing from the status alone.
 */
export const apiErrorCodeSchema = z.enum([
    /** Request body or params failed schema validation. Accompanied by `details`. */
    'validation_failed',
    /** Credentials did not match, or no credentials were supplied. */
    'invalid_credentials',
    /** A valid token is required and was missing, malformed or expired. */
    'unauthorized',
    /** The authenticated user may not perform this action. */
    'forbidden',
    /** The addressed resource does not exist. */
    'not_found',
    /** The request conflicts with existing state, e.g. an email already registered. */
    'conflict',
    /** Too many attempts in a short window; retry later. Used by sign-in lockouts. */
    'rate_limited',
    /** A service the request depends on (the organisation directory) cannot be reached. */
    'unavailable',
    /** Unexpected server-side failure. Details are logged, never returned. */
    'internal_error',
]);
export const apiErrorSchema = z.object({
    error: z.object({
        code: apiErrorCodeSchema,
        /** Human-readable and safe to surface; never leaks internals. */
        message: z.string(),
        /** Field-level validation problems, present only for `validation_failed`. */
        details: z
            .array(z.object({
            path: z.string(),
            message: z.string(),
        }))
            .optional(),
    }),
});
//# sourceMappingURL=error.js.map